import React from 'react';
import './Background.css'
const Background = () => {
    return (
      <div className="css-dy23sn">
        <svg
          xmlns="http://www.w3.org/2000/svg"
          viewBox="0 0 868 631"
          fill="none"
          className="bg1 css-1rl9kp6"
        >
          <g opacity="0.7" filter="url(#filter0_f_5498_46021)">
            <path
              d="M-134 149.5L290 54L669.5 229.5V418L-42.5 479L-134 149.5Z"
              fill="url(#paint0_linear_5498_46021)"
            />
          </g>
          <defs>
            <filter
              id="filter0_f_5498_46021"
              x={-332}
              y={-144}
              width="1199.5"
              height={821}
              filterUnits="userSpaceOnUse"
              colorInterpolationFilters="sRGB"
            >
              <feFlood floodOpacity={0} result="BackgroundImageFix" />
              <feBlend
                mode="normal"
                in="SourceGraphic"
                in2="BackgroundImageFix"
                result="shape"
              />
              <feGaussianBlur
                stdDeviation={99}
                result="effect1_foregroundBlur_5498_46021"
              />
            </filter>
            <linearGradient
              id="paint0_linear_5498_46021"
              x1="37.5"
              y1={-22}
              x2={488}
              y2="314.5"
              gradientUnits="userSpaceOnUse"
            >
              <stop stopColor="#154094" />
              <stop offset={1} stopColor="#0C2033" stopOpacity={0} />
            </linearGradient>
          </defs>
        </svg>
        <svg
          xmlns="http://www.w3.org/2000/svg"
          viewBox="0 0 1243 392"
          fill="none"
          className="bg2 css-8l2ygp"
        >
          <g opacity="0.6" filter="url(#filter0_f_5498_46022)">
            <path
              d="M1231.5 -31.3447L1201 91.4463L939.5 144L724.5 193.5L262 193.5L198 -31.3447L889.5 -96.3449L1231.5 -31.3447Z"
              fill="url(#paint0_linear_5498_46022)"
            />
          </g>
          <defs>
            <filter
              id="filter0_f_5498_46022"
              x={0}
              y="-294.345"
              width="1429.5"
              height="685.845"
              filterUnits="userSpaceOnUse"
              colorInterpolationFilters="sRGB"
            >
              <feFlood floodOpacity={0} result="BackgroundImageFix" />
              <feBlend
                mode="normal"
                in="SourceGraphic"
                in2="BackgroundImageFix"
                result="shape"
              />
              <feGaussianBlur
                stdDeviation={99}
                result="effect1_foregroundBlur_5498_46022"
              />
            </filter>
            <linearGradient
              id="paint0_linear_5498_46022"
              x1="758.5"
              y1="-7.99999"
              x2="7.00042"
              y2={226}
              gradientUnits="userSpaceOnUse"
            >
              <stop stopColor="#762EAF" stopOpacity="0.39" />
              <stop offset={1} stopColor="#140837" stopOpacity={0} />
            </linearGradient>
          </defs>
        </svg>
        <svg
          xmlns="http://www.w3.org/2000/svg"
          viewBox="0 0 854 479"
          fill="none"
          className="bg3 css-7psiy8"
        >
          <g filter="url(#filter0_f_5498_46020)">
            <path
              d="M198.5 207.5L512.5 165L819.5 247L731.5 281L411.5 281L198.5 207.5Z"
              fill="url(#paint0_linear_5498_46020)"
            />
          </g>
          <defs>
            <filter
              id="filter0_f_5498_46020"
              x="0.5"
              y={-33}
              width={1017}
              height={512}
              filterUnits="userSpaceOnUse"
              colorInterpolationFilters="sRGB"
            >
              <feFlood floodOpacity={0} result="BackgroundImageFix" />
              <feBlend
                mode="normal"
                in="SourceGraphic"
                in2="BackgroundImageFix"
                result="shape"
              />
              <feGaussianBlur
                stdDeviation={99}
                result="effect1_foregroundBlur_5498_46020"
              />
            </filter>
            <linearGradient
              id="paint0_linear_5498_46020"
              x1={506}
              y1="136.722"
              x2={506}
              y2="475.75"
              gradientUnits="userSpaceOnUse"
            >
              <stop stopColor="#1D7DD7" stopOpacity="0.54" />
              <stop offset={1} stopColor="#0C2033" stopOpacity={0} />
            </linearGradient>
          </defs>
        </svg>
      </div>
    );
}

export default Background;
